<template>
  <v-container v-bind:style="{ 'background-color': color }">
    <v-card id="dropzone" flat :height="height || defaultHeight">
      <input
        type="file"
        style="display: none"
        ref="image"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        @change="onFilePicked"
      />
      <v-container fluid class="pt-5 text-center">
        <v-icon size="100" class="mr-3 primary--text">mdi-cloud-upload</v-icon>
        <h2 class="mt-1">{{ $t("base.DragAndDrop.uploadHolder") }}</h2>
        <p class="mt-4">{{ $t("excel.ExcelDragAndDrop.or") }}</p>
        <v-btn :loading="loading" class="primary" @click="$refs.image.click()">{{
          $t("excel.ExcelDragAndDrop.searchFile")
        }}</v-btn>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
export default {
  props: ["title", "height", "loading"],
  data() {
    return {
      isHovering: false,
      counter: 0,
      defaultHeight: 160,
    };
  },
  computed: {
    color() {
      console.log(this.isHovering);
      return this.isHovering ? this.$vuetify.theme.themes.light.primary : "#f5f6fa";
    },
  },

  methods: {
    onFilePicked(e) {
      const { files } = e.target;
      if (files[0] !== undefined) {
        this.$emit("update:file", files[0]);
      }
    },
  },
  mounted() {
    const self = this;
    window.addEventListener("dragenter", () => {
      self.isHovering = true;
      self.counter += 1;
      //   console.log("isHOvering->", self.isHovering);
    });

    window.addEventListener("dragleave", (e) => {
      e.preventDefault();

      self.counter -= 1;
      if (self.counter === 0) {
        self.isHovering = false;
        // console.log("dragLeave->", self.isHovering);
      }
    });

    window.addEventListener("dragover", (e) => {
      e.preventDefault();
    });

    window.addEventListener("drop", (e) => {
      e.preventDefault();
      const file = e.dataTransfer.files[0];
      if (!self.loading) {
        console.log("Drop files:", file);
        self.$emit("update:file", file);
      }
    });
  },
};
</script>

<style>
/* .dragContainer {
      background-color: #f5f6fa;
    } */
#dropzone {
  background-color: transparent;
  border-style: dashed;
  border-width: 2px;
  border-color: var(--v-primary-base);
}
</style>
